import {
    API_MODELS_YOU_MAKE_LIKE_CONFIG,
    API_MODELS_YOU_MAKE_LIKE_MODELS,
    API_MODELS_YOU_MAY_LIKE_MUTATE,
} from '../../constants/endpoints'
import { controller } from '../../utilities/abortController'
import { EdgeApiResponse } from './utilities'

export enum MYML_LOCATIONS {
    menu = 'menu',
    recommendationPage = 'recommendationPage',
}

export enum MYML_SEARCH_TYPES {
    single = 'single',
    multiple = 'multiple',
}

type RecommendedModel = {
    id: number
    ranking: number
}
export type RecommendedModels = Array<RecommendedModel>

/**
 * Wrapper for lookupMultipleModelRecommendatons()
 */
export const lookupModelsYouMayLike = async (
    id: number,
): Promise<RecommendedModels> => {
    const results = await lookupMultipleModelRecommendatons([id])
    return results.map((model) => {
        return { id: model.user_id, ranking: model.similarity }
    })
}

export interface BaseApiEdgeModel {
    chat_text_color: string
    chat_text_font_flags: number
    chat_text_font: number
    style_string: string
    user_id: number
    username: string
}

export interface Recommendation extends BaseApiEdgeModel {
    room_topic: string
    similarity: number
}

export interface MultipleModelRecommendationsResponse extends EdgeApiResponse {
    result: { recommendations: Array<Recommendation> }
}

export const lookupMultipleModelRecommendatons = async (
    modelIds: Array<number>,
) => {
    const endpoint = API_MODELS_YOU_MAKE_LIKE_MODELS
    const response = await fetch(
        `${endpoint}?${new URLSearchParams({
            model_ids: modelIds.toString().replaceAll(',', '+'),
            user_details: '1',
            no_cache: Date.now().toString(),
        })}`,
        { credentials: 'include', signal: controller.signal },
    )
    const res: MultipleModelRecommendationsResponse = await response.json()
    return res?.result?.recommendations || []
}

export interface ModelPoolEntry extends BaseApiEdgeModel {
    checked?: boolean
}
interface ModelsYouMayLikeConfigResponse extends EdgeApiResponse {
    result: {
        options: {
            primary_recommend_model: number
        }
        model_config: Array<ModelPoolEntry>
    }
}

export const lookupModelsYouMayLikeConfig = async () => {
    const endpoint = API_MODELS_YOU_MAKE_LIKE_CONFIG
    const response = await fetch(
        `${endpoint}?${new URLSearchParams({
            user_details: '1',
        })}`,
        { credentials: 'include', signal: controller.signal },
    )
    const res: ModelsYouMayLikeConfigResponse = await response.json()
    const { err, result } = res
    const { model_config, options } = result
    if (err) {
        throw new Error(err.toString())
    }

    return {
        primaryRecommendedModel: options.primary_recommend_model,
        modelPool: Array.from(
            model_config.map((model) => {
                return {
                    ...model,
                    checked: model.user_id === options.primary_recommend_model,
                }
            }),
        ),
    }
}

export const addModelToYouMayLikeConfig = async (modelId: number) => {
    const endpoint = API_MODELS_YOU_MAY_LIKE_MUTATE
    try {
        const response = await fetch(
            `${endpoint}?${new URLSearchParams({
                model_id: modelId.toString(),
            })}`,
            {
                credentials: 'include',
                method: 'POST',
                signal: controller.signal,
            },
        )
        const res = await response.json()
        const { err, result } = res
        if (err) {
            throw new Error(err.toString())
        }
        if (result === 1) return true
        else return false
    } catch (ex) {
        console.error(`[addModelToYouMayLikeConfig]: Error Fetching ${ex}`)
    }
}

export const removeModelFromYouMayLikeConfig = async (modelId: number) => {
    const endpoint = API_MODELS_YOU_MAY_LIKE_MUTATE
    try {
        const response = await fetch(
            `${endpoint}?${new URLSearchParams({
                model_id: modelId.toString(),
            })}`,
            {
                credentials: 'include',
                method: 'DELETE',
                signal: controller.signal,
            },
        )
        const res = await response.json()
        const { err, result } = res
        if (err) {
            throw new Error(err.toString())
        }
        if (result === 1) return true
        else return false
    } catch (ex) {
        console.error(`[removeModelFromYouMayLikeConfig]: Error Fetching ${ex}`)
    }
}
